import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { FilterModel } from '../../model/filter-model';
import { VideoQueryElementsComponent } from "../video-query-elements/video-query-elements.component";

@Component({
  selector: 'app-video-filter',
  templateUrl: 'video-filter.component.html',
  styleUrls: ['video-filter.component.scss'],
  standalone: true,
  imports: [
    CommonModule, FormsModule, MatIcon,
    VideoQueryElementsComponent
  ],
})
export class VideoFilterComponent implements OnInit {

  @Output() onFiltersApplied: EventEmitter<any> = new EventEmitter();

  filters!: FilterModel;

  constructor() { }

  ngOnInit() {
  }

  applyFilters() {

    if (!this.isFilterApplied()) {
      this.onFiltersApplied.emit(null);
      return;
    }


    const filters = {
      ...this.filters,
      dateStart: this.filters.dateStart ? new Date(this.filters.dateStart).getTime() : null,
      dateEnd: this.filters.dateEnd ? new Date(this.filters.dateEnd).getTime() : null
    };

    this.onFiltersApplied.emit(filters);
  }

  isFilterApplied() {
    return Object.values(this.filters).some(value => value);
  }

  resetFilters() {
    this.filters = {
      gender: '',
      category: '',
      competition: '',
      championship: '',
      dateStart: '',
      dateEnd: '',
    };
    this.applyFilters();
  }




}
